import { useStanQuery } from '@/queries';
import { fetchEmailTemplateVariables, QUERY_KEYS } from '@/lib';

/**
 * Query to fetch email template variables for course mass email
 */
export function useCourseEmailTemplate() {
    return useStanQuery(
        {
            queryKey: [QUERY_KEYS.COURSE_EMAIL_TEMPLATE],
            queryFn: fetchEmailTemplateVariables,
            meta: { error: { sentryMessage: '[COURSE_ANALYTICS] failed-to-fetch-email-template' } },
        },
        true
    );
}
